import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${props => props.theme.spacing.medium};
`

export const Row = styled.div<{ header?: boolean; expandable?: boolean }>`
  display: grid;
  grid-template-columns: ${props => (props.expandable ? '1fr 2fr repeat(2, 5fr) 2fr' : '1fr')};
  grid-template-rows: 1fr;
  padding: ${props => props.theme.spacing.medium};
  background-color: ${props => props.theme.colors.white[500]};
  border: 1px solid #d7d3df;
  border-radius: ${props => props.theme.radius.medium};

  ${props =>
    props.header &&
    css`
      background-color: #d7d3df;
      font-weight: 500;
    `}
`

export const NoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.medium};

  h1 {
    font-size: 1.7rem;
  }

  img {
    width: 100%;
  }
`

export const NoDataContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.large};
  margin-top: ${props => props.theme.spacing.large};
  padding: ${props => props.theme.spacing.xlarge};
  background: url('/assets/new/fav-routes/fav-route-modal-bg.png'),
    linear-gradient(253.87deg, #fff6f1 -4.3%, #d2d2ff 318.65%);
  background-size: contain;
  height: 100%;
  width: 70%;
  border-radius: 1rem;
`

export const NoDataFavIcon = styled.div`
  position: relative;
  img {
    width: auto;
    height: 80px;
  }
`

export const NoDataDescription = styled.div`
  font-weight: 500;
  text-align: center;
`
